export default {
  computed: {
    dataDoughnutCollection() {
      if (Object.keys(this.data.additional_data).length) {

        return {
          labels: this.getLabels(),
          datasets:[
            {
              data: this.getDataSets(),
              backgroundColor: this.getBackground(),
              hoverBackgroundColor: this.getBackground(),
              showLabel: this.showLabel,
            }]
        };
      }

      return {};
    }
  },
  methods: {
    getBackground() {
      let entries = Object.entries(this.data.additional_data.sex);
      return entries.map(item => this.sexConfig[item[0]].color);
    },
    getDataSets() {
      let entries = Object.entries(this.data.additional_data.sex);
      let summ = entries.reduce(function(sum, elem) {
        return sum + Number(elem[1]);
      }, 0);

      return entries.map(item => {
        if (Number(item[1]) === 0) {
          return 0;
        }
        return Math.round(Number(item[1]) / summ *100);
      });
    },
    getLabels() {
      let keys = Object.keys(this.data.additional_data.sex);
      return keys.map(item => this.sexConfig[item].title);
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      doughnutOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 9,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: (value) => {
              if (value === 0) {
                return "";
              }

              return value + '%';
            },
            anchor: "center",
            color: () => {
              return "#ffffff";
            },
            font: {
              weight: "normal",
              size: 14,
              family: "Roboto"
            },
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
